import React from 'react';
import { t } from '../../../i18n';
import './cap-mr-cor.style.scss';

// Ngăn cách nghìn bằng dấu "." (như file download #,##0). Làm tròn về số nguyên.
const fmt = (n) => (n === null || n === undefined || n === '' ? '—' : Math.round(Number(n)).toLocaleString('en-US').replace(/,/g, '.'));

const pct = (n) => (n === null || n === undefined || n === '' ? '' : (Number(n) * 100).toFixed(2) + '%');

const isZeroRow = (r) => !Number(r.mr_bau_without_db) && !Number(r.mr_bau_with_db) && !Number(r.cor_bau_with_db);

// Bảng kết quả STG_MR & COR CAP. props.result = { snapshot_date, cor_max, total, rows }
export default function ResultTable({ result, showMeta = true }) {
    if (!result || !result.total) return null;
    const { snapshot_date, cor_max, total, rows = [] } = result;

    const dataRow = (r, isTotal) => (
        <tr key={r.item} className={isTotal ? 'cmc-row-total' : isZeroRow(r) ? 'cmc-row-zero' : ''}>
            <td className='cmc-c-date'>{r.date}</td>
            <td className='cmc-c-item'>{r.item}</td>
            <td>{fmt(r.mr_bau_without_db)}</td>
            <td>{isTotal ? '100%' : <span className='cmc-w'>{pct(r.weight)}</span>}</td>
            <td>{fmt(r.mr_bau_with_db)}</td>
            <td>{fmt(r.mr_stress_with_db)}</td>
            <td>{fmt(r.cor_bau_with_db)}</td>
            <td>{fmt(r.cor_stress_with_db)}</td>
        </tr>
    );

    return (
        <div className='cmc'>
            {showMeta && (
                <div className='cmc-meta'>
                    <span className='cmc-pill'>
                        <b>{t('rstg.meta.snapshot')}</b> {snapshot_date}
                    </span>
                    <span className='cmc-pill'>
                        <b>{t('rstg.meta.cor')}</b> {cor_max}
                    </span>
                    <span className='cmc-pill'>
                        <b>{t('rstg.meta.desks')}</b> {rows.length}
                    </span>
                </div>
            )}
            <div className='cmc-table-wrap'>
                <table className='cmc-table'>
                    <thead>
                        <tr>
                            <th>{t('rstg.th.date')}</th>
                            <th>{t('rstg.th.item')}</th>
                            <th>{t('rstg.th.mrBauWo')}</th>
                            <th>{t('rstg.th.weight')}</th>
                            <th>{t('rstg.th.mrBauW')}</th>
                            <th>{t('rstg.th.mrStressW')}</th>
                            <th>{t('rstg.th.corBau')}</th>
                            <th>{t('rstg.th.corStress')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataRow(total, true)}
                        {rows.map((r) => dataRow(r, false))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// src/pages/Raroc/CapMrCor/ResultTable.js